import React from 'react';

const BarChartIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            width="24"
            height="24"
            {...props}
        >
            <path d="M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z" />
        </svg>
    );
};

export default BarChartIcon; 